export default __webpack_public_path__ + "static/media/auto1.780477c6.jpg";